import { ClickToCopyId } from "@/components/common/ClickToCopyId";

interface CopyableSerialNumberProps {
  value: string;
  className?: string;
  /**
   * When set, always show only the last N characters in the chip
   * (full `value` is still copied / used as tooltip).
   */
  compactSuffixLength?: number;
}

function formatCompactSuffix(value: string, suffixLength: number): string {
  if (value.length <= suffixLength) {
    return value;
  }
  return value.slice(-suffixLength);
}

export function CopyableSerialNumber({
  value,
  className,
  compactSuffixLength,
}: CopyableSerialNumberProps) {
  const shown =
    compactSuffixLength != null
      ? formatCompactSuffix(value, compactSuffixLength)
      : value;

  return (
    <ClickToCopyId
      value={value}
      displayValue={shown}
      className={className}
      title={value}
      ellipsis="start"
    />
  );
}
